'use client';

import { Button, buttonTag } from '@ni/nimble-components/dist/esm/button';
import { wrap } from '../utilities/react-wrapper';

export { buttonTag };
export { type Button };
export const NimbleButton = wrap(Button);
